import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CircleNotch, Warning } from "@phosphor-icons/react";

export default function DocDownload() {
  const { fileId } = useParams();
  const navigate = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get(`/project-files/${fileId}/resolve`);
        const raw = data.storage_path || "";
        const path = raw.startsWith("/api/files/") ? raw.slice("/api/files/".length) : raw;
        const resp = await api.get(`/files/${path}`, { responseType: "blob" });
        if (!active) return;
        const url = window.URL.createObjectURL(resp.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = data.name || "document";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setTimeout(() => {
          if (active) navigate(data.project_id ? `/projects/${data.project_id}` : "/", { replace: true });
        }, 1000);
      } catch (e) {
        if (active) setErr("Documentul nu a putut fi găsit sau a fost șters.");
      }
    })();
    return () => { active = false; };
  }, [fileId, navigate]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center text-muted-foreground" data-testid="doc-download">
      {err ? (
        <div className="text-center">
          <Warning size={40} className="mx-auto mb-3 text-red-400" weight="fill" />
          <p className="text-red-400" data-testid="doc-download-error">{err}</p>
          <button onClick={() => navigate("/")} className="mt-4 text-sm text-primary hover:underline">Înapoi la aplicație</button>
        </div>
      ) : (
        <div className="text-center">
          <CircleNotch size={40} className="mx-auto mb-3 animate-spin text-primary" />
          <p>Se descarcă documentul…</p>
        </div>
      )}
    </div>
  );
}
